/**
 * Fenêtre de migration du site partenaire Reducce
 * Mardi 10 mars 2026, 00h00 - 06h00 (heure de Paris)
 */
const MIGRATION_START = new Date('2026-03-10T00:00:00+01:00');
const MIGRATION_END = new Date('2026-03-10T06:00:00+01:00');

export const isInMigrationWindow = () => {
    // Pour tester : ajouter REACT_APP_FORCE_MIGRATION_WARNING=true dans .env
    if (process.env.REACT_APP_FORCE_MIGRATION_WARNING === 'true') return true;
    const now = new Date();
    return now >= MIGRATION_START && now < MIGRATION_END;
};

export const MIGRATION_MESSAGE = "En raison d'une migration majeure du site partenaire (mardi 10 mars 2026, 00h00 - 06h00), certains éléments peuvent être indisponibles. Souhaitez-vous continuer ?";
